import { camelcaseKeys } from 'src/utils/camelize-keys';
import { decamelizeKeys } from 'src/utils/decamelize-keys';

/** @typedef { import('./_types').Task } Task */

/** @type {(task: any) => Task} */
export function normalizeTask(task) {
  let normalized = camelcaseKeys(task, { deep: true });
  normalized.defaultPayrate = centsToDollars(normalized.defaultPayrate);
  return normalized;
}

/** @type {(visit: Partial<Task>) => any} */
export function denormalizeTask(task) {
  if (task.defaultPayrate) {
    task.defaultPayrate = dollarsToCents(task.defaultPayrate);
  }
  return decamelizeKeys(task, { deep: true });
}

/** @type {(cents: number) => number} */
function centsToDollars(cents) {
  return cents / 100.0;
}

/** @type {(dollars: number) => number} */
function dollarsToCents(dollars) {
  return dollars * 100;
}
